// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TestimonalsCard_wrapper__h2g0y"};